import { createSelector } from 'reselect'

import { RootState } from 'core/reducers'

const getRegistrationFormsState = (state: RootState) => state?.registrationForms

export const getRegistrationFormsList = createSelector([getRegistrationFormsState], (state) => state?.list)

export const getRegistrationFormsListData = createSelector([getRegistrationFormsList], (state) => state?.data)

export const getCriteria = () => {
  const criteria = []

  return criteria
}
